import React from "react";
import { PersonAvatar } from "@/components/avatar/PersonAvatar.jsx";

/**
 * @param {{
 *   displayName?: string,
 *   photoUrl?: string|null,
 *   size?: 'sm'|'md'|'lg',
 *   onClick?: () => void,
 *   testId?: string,
 * }} props
 */
export function KarateUserAvatar({ displayName, photoUrl = null, size = "md", onClick, testId = "karate-user-avatar" }) {
  const clickable = Boolean(onClick);
  const avatar = <PersonAvatar displayName={displayName} photoUrl={photoUrl} size={size} testId={testId} />;

  if (!clickable) return avatar;

  return (
    <button
      type="button"
      className="karate-user-avatar-btn"
      onClick={onClick}
      data-testid={`${testId}-button`}
      aria-label={displayName || "Profil utilisateur"}
      title={displayName || "Profil utilisateur"}
    >
      {avatar}
      {displayName ? <span className="karate-user-avatar-btn__name">{displayName}</span> : null}
    </button>
  );
}
